import { render, staticRenderFns } from "./GClassManagementCompetencyRankCard.vue?vue&type=template&id=007d2353&scoped=true&"
import script from "./GClassManagementCompetencyRankCard.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementCompetencyRankCard.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementCompetencyRankCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GClassManagementCompetencyRankCard.vue?vue&type=style&index=1&id=007d2353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007d2353",
  null
  
)

export default component.exports